import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useBackButtonRedirect = (useButton = true) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (useButton) {
      const onBackButtonEvent = (event) => {
        event.preventDefault();
        navigate("/", {
          state: {
            hook: "usingBackButton",
          },
        });
      };

      window.history.pushState(
        null,
        "",
        window.location.pathname + window.location.search
      );
      window.addEventListener("popstate", onBackButtonEvent);

      return () => {
        window.removeEventListener("popstate", onBackButtonEvent);
      };
    }
  }, [navigate]);
};

export default useBackButtonRedirect;
